"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reportError = reportError;
const appsignal_1 = require("./appsignal");
function reportError(error) {
    if (appsignal_1.appsignal) {
        appsignal_1.appsignal.sendError(error instanceof Error ? error : new Error(String(error)));
    }
}
